import { render, staticRenderFns } from "./jd-otherDate-range.vue?vue&type=template&id=db008974&scoped=true&"
import script from "./jd-otherDate-range.vue?vue&type=script&lang=js&"
export * from "./jd-otherDate-range.vue?vue&type=script&lang=js&"
import style0 from "./jd-otherDate-range.vue?vue&type=style&index=0&id=db008974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db008974",
  null
  
)

export default component.exports